export const CheckEmailRegulaire = (email) => {
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(email);
};

export const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const options = {
    weekday: "long", // Monday
    year: "numeric", // 2025
    month: "long", // October
    day: "numeric", // 3
  };

  return new Intl.DateTimeFormat("en-GB", options).format(date);
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const options = {
    weekday: "long", // Monday
    year: "numeric", // 2025
    month: "long", // October
    day: "numeric", // 3
    hour: "2-digit", // 14
    minute: "2-digit", // 30
    hour12: false, // 24-hour format
  };

  return new Intl.DateTimeFormat("en-GB", options).format(date);
};

export const formatDateForMySQL = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  const formattedDate = date.toISOString().slice(0, 19).replace("T", " ");

  return formattedDate;
};
